import {Translate} from "@components/Theme/Translate/Translate"
import Truncate from "@hooks/Truncate"
import parse from "html-react-parser"
import {ReactNode, useMemo} from "react"

export interface ProcessOptions {
	stripHtml?: boolean
	translate?: boolean
	truncate?: number
}

const useProcessedContent = (
	raw: string | ReactNode | undefined,
	opts: ProcessOptions,
): ReactNode | undefined => {
	const {stripHtml = false, translate = false, truncate} = opts

	return useMemo(() => {
		if (raw == null) return undefined
		if (typeof raw !== "string") return raw

		let text = raw

		if (stripHtml) {
			// Remove the blog-img-caption class from the preview text
			// All image captions should be wrapped in a <p> tag with the class blog-img-caption
			text = text.replace(
				/<p\b[^>]*\bclass\s*=\s*["'][^"']*\bblog-img-caption\b[^"']*["'][^>]*>[\s\S]*?<\/p>/gi,
				"",
			)
			text = text.replace(/&nbsp;|&#160;|&#x0*a0;/gi, " ")
			text = text.replace(/\r\n?/g, "\n")
			text = text.replace(/<div\b[^>]*>\s*<\/div>/gi, "\n")
			text = text.replace(/<br\s*\/?>/gi, "\n")
			text = text.replace(/<\/(?:p|div|h[1-6]|li|blockquote)>/gi, "\n")
			text = text.replace(/<[^>]+>/g, "")
			text = text.replace(/&amp;/g, "&")
			text = text.replace(/&[^;]+;/g, "")
			text = text.replace(/[ \t]+\n/g, "\n")
			text = text.replace(/\n[ \t]+/g, "\n")
			text = text.replace(/\n{3,}/g, "\n\n")
			text = text.trim()
		}

		if (truncate && truncate > 0) {
			const maybe = Truncate(text, truncate)
			if (typeof maybe === "string") text = maybe
		}

		const parsed = stripHtml ? text : parse(text)

		if (translate && typeof parsed === "string") {
			return <Translate>{parsed}</Translate>
		}

		return parsed
	}, [raw, stripHtml, translate, truncate])
}

export default useProcessedContent
